import { IdiomaCalendario } from './../../../domain/IdiomaCalendatio';
import { Component, OnInit, OnDestroy, ViewEncapsulation, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser'

import { Message, MenuItem } from 'primeng/primeng';
import { ConfirmationService } from 'primeng/api';
import { TranslateService} from 'ng2-translate';
import { BreadcrumbService } from '../../../breadcrumb.service';
import { AuthenticationService } from '../../../providers/authentication/authentication.service';
import { EntityManagerProvider } from '../../../providers/entity-manager-provider/entity-manager-provider';
import { ServiciosWebServiceProvider } from '../../../providers/web-service-service/servicios-web-service';
import { ScrollToService } from '@nicky-lenaers/ngx-scroll-to';
import { Contenido, ContenidoIdiomaFormulario } from './../../../domain/Contenido';
import { WebExterna } from './../../../domain/WebExterna';
import { Foto } from './../../../domain/Foto';

import * as allSettled from 'promise-all-settled';

import { SeccionPlano } from 'interiores-mapa';
import { ContenidoPlano } from 'interiores-mapa';
import { Predicate } from 'breeze-client';
import { Idioma } from '../../../domain/Idioma';
import { IdiomaService } from '../../../providers/idioma/idioma.service';
import { ImageCropperComponent, CropperSettings } from 'ngx-img-cropper';
import { Constantes } from '../../../domain/constantes';

import {PlanoComponent} from 'interiores-mapa';
import { NodoFormulario } from '../../../domain/NodoFormulario';
import { SeccionFormulario } from '../../../domain/SeccionFormulario';
import { AlaFormulario } from './../../../domain/AlaFormulario';
import { EspacioFormulario } from './../../../domain/EspacioFormulario';
import { Permisos, PermisosService } from '../../../providers/authentication/permisos.service';
import { AppComponent } from '../../../app.component';
import { environment } from '../../../../environments/environment';
import {Modelo3D} from '../../../domain/Modelo3D';

import Speech from 'speak-tts';

import {QRCodeComponent } from 'angularx-qrcode';
import { TipoLocalizacion } from '../../../domain/TipologiaContenidoFormulario';
import { ServiciosStatsProvider } from '../../../providers/web-service-service/servicios-stats';
import { InformesService } from '../../../providers/informes/informes.service';
import { forEach } from '@angular/router/src/utils/collection';
import { CKEditor4 } from 'ckeditor4-angular/ckeditor';
import { IfObservable } from 'rxjs/observable/IfObservable';

@Component({
	selector: 'app-hero-form-reactive',
	templateUrl: './nuevo.contenido.component.html',
	styleUrls: ['./nuevo.contenido.component.scss'],
	encapsulation: ViewEncapsulation.None,
    providers: [ConfirmationService, ScrollToService]

})

export class NuevoContenidoComponent implements OnInit, OnDestroy {

	public esEdicion = false;
	public edicionWeb = false;

	public msgPosicionar = [];

	public hideContenido = false;
	public hideAudioguia = false;
	public hideWebExterna = false;
	public hideAsociarElemento = false;
	public hidePosicionarElemento = false;
	public hideModelo3d = false;

	// Control de descarga por pastañas
	public posicionarElementoDescargado = false;
	public asociarElementoDescargado = false;
	public websDesargadas = false;

	public activeAcordeonIndex = 0;

	public tabMenuItems: MenuItem[];
	public activeItem: MenuItem;

	public displayDialogWebExterna: boolean;
	// IDpublic displayDialogPrioridadDestacar = false;

	public columnasTablaWebExternas: any[];
	public tipologiasContenido: any[] = [];

	public contenidoSeleccionado: Contenido = new Contenido();
	public WebExternaSeleccionada: WebExterna;

	// Selector Drag&Drop
	public listaNodos: NodoFormulario[] = [];
	public listaEspacios: EspacioFormulario[] = [];
	public listaAlas: AlaFormulario[] = [];
	public listaSecciones: SeccionFormulario[] = [];

	public listaEntidades: any[] = []; // Lista de Todas las entidades que hemos Obtenido en esta pagina
	public listaEntidadesDestacar: any[] = []; // Lista de entidades asignables al contenido que aun no han sido asignadas
	public listaSeleccionados: any[] = []; // Lista de entidades asignadas al contenido
	public listaNodosSeleccionados: NodoFormulario[] = []; // Lista de nodos asignados (SOLO SE PERMITE UNO), para alimentar formmularioposicionarContenido
	listaRelacionesEliminadas: any[] = []; // lista donde almacenaremos las relaciones eliminadas a la hora de guardar para poder recuperar las prioridades

	// Parametros Route para contenido a editar
	public idEditar;
	public tipoEntidadEditar;

	// Validacion
	public confirmacionVisible = false;
	public operacion = '';
	public msgsValidacion: Message[] = [];

	public isValid = true;
	public tituloError = false;
	public fAltaError = false;
	public fBajaError = false;
	public imagenError = false;

	public contenidosSeleccionados = [];

	public contenidosDestacar = [];
	// Mensajes
	msgs: Message[] = [];
	spinner: HTMLElement;
	blockUI: HTMLElement;
	public cols_destacar: any[];
	// Calendario
	idiomaCalendario: IdiomaCalendario;
	contenido: any;

	public mensajesExpirados = [
		{
			tipo: 'TODOS',
			value: 4,
			clases: [],
			label: 'Contenidos.estadoTodos'
		},
		{
			tipo: 'PROXIMOACT',
			value: 5,
			clases: [],
			label: 'Contenidos.estadoProximoAct'
		},
		{
			tipo: 'ACTIVO',
			value: 3,
			clases: ['ui-message', 'ui-corner-all'],
			label: 'Contenidos.estadoActivo'
		},
		{
			tipo: 'PROXIMO',
			value: 1,
			clases: ['ui-message', 'ui-messages-warning', 'ui-corner-all'],
			label: 'Contenidos.estadoProximo'
		},
		{
			tipo: 'EXPIRADO',
			value: 0,
			clases: ['ui-message', 'ui-messages-error', 'ui-corner-all'],
			label: 'Contenidos.estadoExpirado'
		}
	];
	/* MAPA */
	@ViewChild('planoPosicion') planoPosicion: PlanoComponent;
	pathPlano: String;
	zoomLevels: Number[];
	zoomCenterCoords: Number[];
	sections: Array<SeccionPlano> = [];
	mapSections: Map<String, SeccionPlano>;
	contents: Array<ContenidoPlano> = [];
	mapContents: Map<String, ContenidoPlano>;

	idAla: string;
	// alaSeleccionada: AlaFormulario;
	seccionDefecto: SeccionFormulario;
	public seccionClicada: SeccionFormulario;

	public seccionSeleccionada;
	public espacioSeleccionado;
	public alaSeleccionada;

	displayDialogPosicion = false;

	public offset_x_icono_contenido = -30;
	public offset_y_icono_contenido = -30;

	/* IDIOMA */
	idiomas;
	idiomaSeleccionado: Idioma;
	idiomaDefecto: Idioma;

	/* IMAGE CROPPER*/
	data: any;
	cropperSettings: CropperSettings;
	imageCropperVisible = false;
	@ViewChild('cropper', undefined) cropper: ImageCropperComponent;

	/* MODELO 3D */

	modeloSeleccionado: Modelo3D = new Modelo3D();

	selectorImagenModelo_ios: any;
	ficheroModeloSeleccionado_ios: any;
	urlModeloSeleccionado_ios: string = undefined;

	selectorImagenModelo_android: any;
	ficheroModeloSeleccionado_android: any;
	urlModeloSeleccionado_android: string = undefined;

	public permisos: Permisos = new Permisos();

	public speech;

	//direccion nueva imagen detalle seleccionada
	public srcNuevaImagenDetalle: string;

	// QR
	valueQR = '';

	//ckeditor config
	public ckEditorConfig: any = {
		extraPlugins:
		  "dialogui,dialog,a11yhelp,about,basicstyles,bidi,blockquote,clipboard," +
		  "button,panelbutton,panel,floatpanel,colorbutton,colordialog,menu," +
		  "contextmenu,dialogadvtab,div,elementspath,enterkey,entities,popup," +
		  "filebrowser,find,fakeobjects,floatingspace,listblock,richcombo," +
		  "font,format,horizontalrule,htmlwriter,indent," +
		  "indentblock,indentlist,justify,link,list,liststyle,magicline," +
		  "maximize,newpage,pagebreak,pastefromword,pastetext,preview,print," +
		  "removeformat,resize,save,menubutton,scayt,selectall,showblocks," +
		  "showborders,smiley,sourcearea,specialchar,stylescombo,tab,table," +
		  "tabletools,templates,toolbar,undo,wsc,wysiwygarea,easyimage",
		removePlugins: "image",
		easyimage_toolbar:  [ 'EasyImageAlignLeft', 'EasyImageAlignCenter', 'EasyImageAlignRight' ]
		

	  };

	public fotosCarrusel: Foto[] = []


	constructor(
		private informesService: InformesService,
		private appComponent: AppComponent,
		private router: Router,
		private breadcrumbService: BreadcrumbService,
		private entityManager: EntityManagerProvider,
		public sws: ServiciosWebServiceProvider,
		private swsStats: ServiciosStatsProvider,
		public authService: AuthenticationService,
		private route: ActivatedRoute,
		private confirmationService: ConfirmationService,
		public translate: TranslateService,
		private idiomaService: IdiomaService,
		private permisosService: PermisosService,
		private sanitizer: DomSanitizer
	) {
		this.valueQR = 'Techiediaries';

		this.cropperSettings = new CropperSettings();
		this.cropperSettings.width = 400;
		this.cropperSettings.height = 400;
		this.cropperSettings.croppedWidth = 400;
		this.cropperSettings.croppedHeight = 400;
		this.cropperSettings.canvasWidth = 400;
		this.cropperSettings.canvasHeight = 400;
		this.cropperSettings.noFileInput = true;
		this.cropperSettings.fileType = "image/webp";
		this.cropperSettings.minWithRelativeToResolution = true;

		this.data = {};
		this.breadcrumbService.setItems([
			{ label: this.translate.instant('Contenidos.contenidos'), routerLink: ['/contenidos'] },
			{ label: this.translate.instant('Contenidos.nuevocontenido') }
		]);

		this.idiomaCalendario = new IdiomaCalendario();
		this.idiomaCalendario.firstDayOfWeek = 1;
		this.idiomaCalendario.dayNames = this.translate.instant('Calendario.dayNames');
		this.idiomaCalendario.dayNamesShort = this.translate.instant('Calendario.dayNamesShort');
		this.idiomaCalendario.dayNamesMin = this.translate.instant('Calendario.dayNamesMin');
		this.idiomaCalendario.monthNames = this.translate.instant('Calendario.monthNames');
		this.idiomaCalendario.monthNamesShort = this.translate.instant('Calendario.monthNamesShort');
		this.idiomaCalendario.today = this.translate.instant('Calendario.today');
		this.idiomaCalendario.clear = this.translate.instant('Calendario.clear');

		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		this.spinner.style.display = 'none';

		this.blockUI = document.getElementsByClassName('blockPosicionarContenido')[0] as HTMLElement;
		if (this.blockUI) {
			this.blockUI.style.display = 'none';
		}


		this.speech = new Speech(); // will throw an exception if not browser supported

		if (this.speech.hasBrowserSupport()) { // returns a boolean
			console.log('speech synthesis supported');
			this.speech.init().then((data) => {
				// The "data" object contains the list of available voices and the voice synthesis params
				console.log('Speech is ready, voices are available', data);
			}).catch(e => {
				console.error('An error occured while initializing : ', e);
			});
		}
	}

//#region -- INIT --
	formContenido: FormGroup;

	ngOnInit() {
		window.scroll(0, 0);
		console.log('Carga nuevo contenido');
		this.listaNodos = [];
		this.listaEspacios = [];
		this.listaAlas = [];
		this.listaSecciones = [];
		this.listaEntidades = [];
		this.listaSeleccionados = [];
		this.listaNodosSeleccionados = [];
		this.listaEntidadesDestacar = [];

		// Mostramos Spinner
		this.spinner.style.display = 'inherit';

		this.route.params
			.subscribe(params => {
				this.idEditar = params['id'];
				this.tipoEntidadEditar = params['entidad'];
			});

		this.tabMenuItems = [
			{
				label: this.translate.instant('Contenidos.edicioncontenido'),
				icon: 'iticon-tab-editar',
				command: (event: any) => {
					this.tabContenidoSeleccionada(event);
				}
			},
			{
				label: this.translate.instant('Contenidos.audioguia'),
				icon: 'iticon-tab-audioguia',
				command: (event: any) => {
					this.tabAudioguiaSeleccionada(event);
				}
			},
			{
				label: this.translate.instant('Contenidos.enlacesexternos'),
				icon: 'iticon-tab-enlaces-externos',
				command: (event: any) => {
					this.tabWebExternasSeleccionada(event);
				}
			},
			{
				label: this.translate.instant('Contenidos.posicionarenmapa'),
				icon: 'iticon-tab-ubicacion-contenido-en-mapa ',
				command: (event: any) => {
					this.tabPosicionarSeleccionada(event);
				}
			},
			{
				label: this.translate.instant('Contenidos.destacarContenidoEn'),
				icon: 'iticon-tab-asignacion-contenido ',
				command: (event: any) => {
					this.tabAsociarSeleccionada(event);
				}
			}

		];

		// Columnas Taba WebExternas
		this.columnasTablaWebExternas = [
			{ field: 'Nombre', header: this.translate.instant('Contenidos.titulo') },
			{ field: 'Url', header: this.translate.instant('Contenidos.url') },
			{ field: 'MostrarEdicion', header: '' }
		];

		this.cols_destacar = [
			{ field: 'Drag', header: '' },
			{ field: 'Imagen', fieldSort: '', header: this.translate.instant('Contenidos.imagen')}, //  clases: ['th-tipo-corto1']},
			{ field: 'Titulo', fieldSort: 'Titulo', header: this.translate.instant('Contenidos.titulo')}, //  clases: ['th-tipo-normal'] },
			{ field: 'IdAlternativo', fieldSort: 'IdAlternativo', header: this.translate.instant('Contenidos.idAlternativo')}, //  clases: ['th-tipo-medio'] },
			{ field: 'expirado', fieldSort: 'expirado', header: this.translate.instant('Contenidos.estado')} //  clases: ['th-tipo-corto2'] }
		];

		this.tabContenidoSeleccionada(null);

		const that = this;
		this.entityManager.getIDIOMA()
		.then(function (idiomasENTIDAD: any) {

			that.idiomas = [];
			idiomasENTIDAD.forEach(idioma => {
				if(idioma.Visible === true){
				that.idiomas.push(new Idioma(idioma));
				}
			});

			that.idiomaDefecto = that.idiomaService.getIdiomaDefecto(that.idiomas);
			that.idiomaSeleccionado = that.idiomaDefecto;

		})
		.then(function () {
			return that.permisosService.obtenerTIPOLOGIA_CONTENIDO();
		})
		.then(function (e) {
			that.tipologiasContenido = e;
			let tipologiasActivas = that.tipologiasContenido.filter(t => t.Activa === true);
			that.tipologiasContenido = tipologiasActivas;
			return that.comprobarPermisos();
		})
		.then(function (ok) {
			console.log('--- CARGA PANTALLA OK ---');
			const includes = 'IDIOMAS';
			const where = undefined;
			return that.prepararEdicionContenido(that.tipoEntidadEditar, that.idEditar);
		})
		.catch(function (err) {
			console.log('--- CARGA PANTALLA ERROR ---');
		});

	}

	ngOnDestroy(): void {
		this.entityManager.RejectChanges();
	}

	nuevoCarrusel(carrusel){
		this.fotosCarrusel = carrusel;
		let idsCarrousel = Array.from(this.fotosCarrusel, x => x.Id);
		
		if(this.contenidoSeleccionado.ENTIDAD && this.contenidoSeleccionado.ENTIDAD.FOTOS && this.contenidoSeleccionado.ENTIDAD.FOTOS.length > 0){
			this.contenidoSeleccionado.ENTIDAD.FOTOS.forEach(f => {
				if(f.Tipo == 1){
					let foto = idsCarrousel.find(x => x == f.Id)
					if(foto === undefined){
						this.entityManager.deleteEntity(f);
					}
				}

			})

		}
	}
	fechaUbicado(): any{
		if(this.contenidoSeleccionado.FechaUltimaLocalizacion){
			return this.contenidoSeleccionado.FechaUltimaLocalizacion
		}else{
			return  this.translate.instant('Contenidos.noUbicado');
		}
	}
	comprobarPermisos() {
		const userId = this.authService.getIdUsuario();
		const that = this;
		return this.permisosService.getPermisosUsuario(userId)
		.then(function(perm: Permisos){
			that.permisos = perm;

			if (that.permisos && that.permisos.Contenido_modelo_3d === 2) {
				that.tabMenuItems.push({
					label: that.translate.instant('Contenidos.modelo3d'),
					icon: 'iticon-ITSN-rev19 ',
					command: (event: any) => {
						that.tabModelo3dSeleccionada(event);
					}
				});
			}

		});
	}




	prepararEdicionContenido(Tipo, Id) {
		const that = this;



		if (Tipo === 'CONTENIDO') {
			/*
			let includes = 'ALAS.ALA.CONTENIDOS.CONTENIDO, ';
			includes = includes + 'ALAS.ALA.NIVEL, ';
			includes = includes + 'ESPACIOS.ESPACIO.CONTENIDOS.CONTENIDO, ';
			includes = includes + 'FOTOS, ';
			includes = includes + 'NODODS.NODO.CONTENIDOS.CONTENIDO, ';
			includes = includes + 'NODODS.NODO.TIPOLOGIA_NODO, ';
			includes = includes + 'ALA_PLANO, ';
			includes = includes + 'IDIOMAS, ';
			includes = includes + 'SECCIONES.SECCION.CONTENIDOS';
			*/

			let includes = '';
			includes = includes + 'FOTOS, ';
			includes = includes + 'NODODS.NODO.SECCION, ';
			includes = includes + 'IDIOMAS, ';
			includes = includes + 'SECCIONES.SECCION, ';
			includes = includes + 'TIPOLOGIA_CONTENIDO, ';
			includes = includes + 'ALA_PLANO, ';
			includes = includes + 'MODELO_3D, ';
			//includes = includes + 'CONTENIDOS, ';
			includes = includes + 'POSICION_ACTUAL_CONTENIDOS, ';
			includes = includes + 'POSICION_ULTIMA_CONTENIDOS';

			this.entityManager.getContenidoById(Id, includes)
			.then(function (contenido) {
				if (contenido && contenido.length > 0) {
					let IDsContenido = [];
					contenido.forEach(c => c.SECCIONES.forEach(s => {
						IDsContenido.push(s.IdContenido);
					})
					);
					// Seteamos el objeto contenidoSeleccionado con los valores del contenido de base de datos
					const CONTENIDO = contenido[0];
					that.contenidoSeleccionado = new Contenido().fromENTIDAD(CONTENIDO);
					that.modeloSeleccionado = new Modelo3D().fromENTIDAD(CONTENIDO.MODELO_3D);
					that.esEdicion = true;
					//TIPOLOGIAS
					if(that.contenidoSeleccionado.TIPOLOGIA_CONTENIDO){

			 				let tipologiasActivas = that.tipologiasContenido.filter(t => t.Activa === true);
			 				that.tipologiasContenido = tipologiasActivas;
							if(that.contenidoSeleccionado.TIPOLOGIA_CONTENIDO !== undefined){

			 					if(that.contenidoSeleccionado.TIPOLOGIA_CONTENIDO.Activa !== true){
			 						tipologiasActivas.push(that.contenidoSeleccionado.TIPOLOGIA_CONTENIDO)
			 						that.tipologiasContenido = tipologiasActivas;

			 					}else{
			 						that.tipologiasContenido = tipologiasActivas;

			 					}
			 				}else{
			 					that.tipologiasContenido = tipologiasActivas;
			 				}


					}
					if (that.contenidoSeleccionado.WebsExternas.length > 0) {
						that.websDesargadas = true;
					}

					if (that.contenidoSeleccionado.ALA_PLANO) {
						that.alaSeleccionada = new AlaFormulario(that.contenidoSeleccionado.ALA_PLANO);
						that.seleccionarAla(that.alaSeleccionada);
					}

					// ALAS
					if (that.contenidoSeleccionado.ENTIDAD.ALAS) {
						that.contenidoSeleccionado.ENTIDAD.ALAS.forEach(element => {
							try {
								const ala = new AlaFormulario(element.ALA);
								if (ala) {
									that.listaSeleccionados.push(ala);
								}
							} catch (e) {
								console.error('ERROR: error al leer un ALA: ' + e);
							}
						});
					}

					// NODOS
					if (that.contenidoSeleccionado.ENTIDAD.NODODS) {
						that.contenidoSeleccionado.ENTIDAD.NODODS.forEach(element => {
							try {
								const nodo = new NodoFormulario().fromENTIDAD(element.NODO);
								if (nodo) {
									that.listaSeleccionados.push(nodo);
									that.listaNodosSeleccionados.push(nodo);
								}

							} catch (e) {
								console.error('ERROR: error al leer un NODO');
							}
						});
					}

					// ESPACIOS
					if (that.contenidoSeleccionado.ENTIDAD.ESPACIOS) {
						that.contenidoSeleccionado.ENTIDAD.ESPACIOS.forEach(element => {
							try {
								const espacio = new EspacioFormulario(element.ESPACIO);
								if (espacio) {
									that.listaSeleccionados.push(espacio);
								}
							} catch (e) {
								console.error('ERROR: error al leer un ESPACIO');
							}
						});
					}

					// SECCIONES
					if (that.contenidoSeleccionado.ENTIDAD.SECCIONES !== undefined && that.contenidoSeleccionado.ENTIDAD.SECCIONES.length > 0) {
						that.contenidoSeleccionado.ENTIDAD.SECCIONES.forEach(element => {
							try {
								const seccion = new SeccionFormulario().fromENTIDAD(element.SECCION);
								if (seccion) {
									that.listaSeleccionados.push(seccion);
								}
							} catch (e) {
								console.error('ERROR: error al leer un SECCION');
							}
						});
					}

					//FOTOS Carrousel
					if(that.contenidoSeleccionado.fotosCarrusel !== undefined && that.contenidoSeleccionado.fotosCarrusel.length > 0){
						that.fotosCarrusel = that.contenidoSeleccionado.fotosCarrusel;
					}

					// POSICIONES
					if(that.contenidoSeleccionado.POSICION_ACTUAL_CONTENIDOS.length >0){
						that.contenidoSeleccionado.FechaUltimaLocalizacion = that.contenidoSeleccionado.POSICION_ACTUAL_CONTENIDOS[0].FechaUbicacion;

						}
					else if(that.contenidoSeleccionado.POSICION_ULTIMA_CONTENIDOS.length >0){
						that.contenidoSeleccionado.FechaUltimaLocalizacion = that.contenidoSeleccionado.POSICION_ULTIMA_CONTENIDOS[0].FechaUbicacion;
						}
					else{
						const token = that.authService.getToken();

						return that.swsStats.getUltimoHistoricoLocalizacionesContenidos(token, IDsContenido).toPromise()
						.then(function(ultimosHistoricos){
							const ultimo = ultimosHistoricos.lista[0];
							if (ultimo) {
								let hasta = new Date(ultimo.FechaHasta);
								//new Date(Date.UTC(ultimo.FechaHasta.getFullYear() , ultimo.FechaHasta.getMonth() , ultimo.FechaHasta.getDate() , ultimo.FechaHasta.getHours() , ultimo.FechaHasta.getMinutes() , ultimo.FechaHasta.getSeconds()));
								that.contenidoSeleccionado.FechaUltimaLocalizacion = hasta;
							}
						})
					}
					// Eliminados las Entidades ya asignadas de la lsita de seleccionables
					that.listaSeleccionados.forEach(element => {
						that.listaEntidadesDestacar = that.listaEntidadesDestacar.filter( x => x.Id !== element.Id);
					});

					if (that.contenidoSeleccionado.Imagen === null || that.contenidoSeleccionado.Imagen === undefined || that.contenidoSeleccionado.Imagen === ''){
						that.contenidoSeleccionado.Imagen = that.authService.getFotoPorDefecto();
					}

					return true;
				}
				else{
					that.contenidoSeleccionado = new Contenido();
					that.contenidoSeleccionado.Imagen = that.authService.getFotoPorDefecto();
					that.contenidoSeleccionado.TIPOLOGIA_CONTENIDO = that.tipologiasContenido[0];

				}
			})
			.then(function(){
				that.spinner.style.display = 'none';
			})
			.catch(function (err){
				console.log('prepararEdicionContenido: ' + err.status);
				that.spinner.style.display = 'none';
				that.appComponent.showError(err.toString());
			});

		} else {
			that.contenidoSeleccionado = new Contenido();
			that.contenidoSeleccionado.Imagen = that.authService.getFotoPorDefecto();
			that.contenidoSeleccionado.TIPOLOGIA_CONTENIDO = that.tipologiasContenido[0];
			that.contenidoSeleccionado.Idiomas = that.idiomaService.newMapContenidoIdiomas(that.idiomas);

			// that.contenidoSeleccionado.ALA_PLANO = that.listaAlas[0];
			that.contenidoSeleccionado.X = Constantes.X_COORDENADA; // 155;
			that.contenidoSeleccionado.Y = Constantes.Y_COORDENADA; // 256;
			that.esEdicion = false;
			that.spinner.style.display = 'none';
		}
	}

	imagenEsNull(ImagenDetalle: string){
		return ImagenDetalle.indexOf('0000000-0000-0000-0000-000000000000') > 0;
	}
//#endregion

//#region -- ASIGNAR --
	onMoveToSource($event){
		console.log('onMoveToSource');
		console.log($event);
	}

	onMoveToTarget($event){
		console.log('onMoveToTarget');
		console.log($event);
	}

	esSeccionContenidoAsignado($event){
		let visibleEnTabla = false;
		if ($event && $event.TIPO === 'SECCION') {
			const nodoSeccion = this.listaNodosSeleccionados.filter( x => x.IdSeccion === $event.Id)[0];
			if (nodoSeccion) {
				visibleEnTabla = true;
			}
		}
		return visibleEnTabla;
	}
//#endregion

//#region -- TAB_MENU --
	tabContenidoSeleccionada(event: any) {

		this.msgPosicionar = [];
		this.activeItem = this.tabMenuItems[0];

		this.ocultarTabs();
		this.hideContenido = false;
		this.displayDialogPosicion = false;
		if (this.blockUI) {
			this.blockUI.style.display = 'none';
		}

	}

	tabAudioguiaSeleccionada(arg0: any): any {
		this.msgPosicionar = [];
		this.activeItem = this.tabMenuItems[1];

		this.ocultarTabs();
		this.hideAudioguia = false;
		this.displayDialogPosicion = false;
		if (this.blockUI) {
			this.blockUI.style.display = 'none';
		}
	}

	tabModelo3dSeleccionada(arg0: any): any {
		this.msgPosicionar = [];
		this.activeItem = this.tabMenuItems[5];

		this.ocultarTabs();
		this.hideModelo3d = false;
		this.displayDialogPosicion = false;
		if (this.blockUI) {
			this.blockUI.style.display = 'none';
		}
	}

	tabWebExternasSeleccionada(event: any) {
		this.msgPosicionar = [];
		this.activeItem = this.tabMenuItems[2];

		this.ocultarTabs();
		this.hideWebExterna = false;
		this.displayDialogPosicion = false;
		if (this.blockUI) {
			this.blockUI.style.display = 'none';
		}
		const that = this;
		if (!this.websDesargadas && this.contenidoSeleccionado.ENTIDAD) {
			that.spinner.style.display = 'inherit';
			this.entityManager.getCONTENIDO_WEB_EXTERNAbyCONTENIDO(this.contenidoSeleccionado.ENTIDAD.Id, 'FOTOS, IDIOMAS')
			.then(function (webs) {
				that.websDesargadas = true;
				const promises: any[] = [];
				webs.forEach(element => {

					const webExterna = new WebExterna();
					webExterna.Nombre = element.Texto;
					webExterna.Url = element.url;
					webExterna.IdWebExterna = element.Id;
					webExterna.ENTIDAD = element;
					webExterna.Idiomas = that.idiomaService.getMapContenidoWebExternaIdiomas(element.IDIOMAS);
					that.contenidoSeleccionado.WebsExternas.push(webExterna);

					element.Imagen = that.authService.getFotoPorDefecto();
					// FOTOS
					const ultima = element.FOTOS.length - 1;
					if (ultima >= 0) {
						if (element.FOTOS[ultima] && element.FOTOS[ultima].UrlFotoExt) {
							element.Imagen = element.FOTOS[ultima].UrlFotoExt;
						}
						else if (element.FOTOS[ultima] && element.FOTOS[ultima].IdFotoExt){
							element.Imagen =  environment.urlBaseFotos + element.FOTOS[ultima].IdFotoExt;
						}
					}
					else {
						element.Imagen = that.authService.getFotoPorDefecto();
					}

				});
				that.spinner.style.display = 'none';
			});
		}
	}

	tabAsociarSeleccionada(event) {

		const that = this;
		if (this.asociarElementoDescargado || this.posicionarElementoDescargado) {
			that.activeItem = that.tabMenuItems[4];
			that.ocultarTabs();
			that.hideAsociarElemento = false;
			that.msgPosicionar = [];
			that.displayDialogPosicion = false;
			if (that.blockUI) {
				that.blockUI.style.display = 'none';
			}
			return true;
		}

		that.spinner.style.display = 'inherit';

		return this.obtenerEntyties()
		.then(function(){
			that.activeItem = that.tabMenuItems[4];
			that.ocultarTabs();
			that.hideAsociarElemento = false;
			that.msgPosicionar = [];
			that.displayDialogPosicion = false;
			if (that.blockUI) {
				that.blockUI.style.display = 'none';
			}
			that.asociarElementoDescargado = true;
			that.spinner.style.display = 'none';
		});
	}

	tabPosicionarSeleccionada(event) {

		const that = this;

		if (this.asociarElementoDescargado || this.posicionarElementoDescargado) {
			that.activeItem = that.tabMenuItems[3];
			that.ocultarTabs();
			that.hidePosicionarElemento = false;
			that.displayDialogPosicion = true;

			that.blockUI = document.getElementsByClassName('blockPosicionarContenido')[0] as HTMLElement;
			if (that.blockUI) {
				that.msgPosicionar = [];
				that.blockUI.style.display = 'inherit';
				that.msgPosicionar.push({severity: 'info', detail: that.translate.instant('Contenidos.avisoDesbloquear') + that.contenidoSeleccionado.Titulo});
			}
			return true;
		}

		that.spinner.style.display = 'inherit';

		return this.obtenerEntyties()
		.then(function(){
			that.activeItem = that.tabMenuItems[3];
			that.ocultarTabs();
			that.hidePosicionarElemento = false;
			that.displayDialogPosicion = true;

			that.blockUI = document.getElementsByClassName('blockPosicionarContenido')[0] as HTMLElement;
			if (that.blockUI) {
				that.msgPosicionar = [];
				that.blockUI.style.display = 'inherit';
				that.msgPosicionar.push({severity: 'info', detail: that.translate.instant('Contenidos.avisoDesbloquear') + that.contenidoSeleccionado.Titulo});
			}

			that.posicionarElementoDescargado = true;
			that.spinner.style.display = 'none';
		})
		.catch(function(){
			that.spinner.style.display = 'none';
		});
	}

	protected ocultarTabs() {
		this.hideContenido = true;
		this.hideWebExterna = true;
		this.hideAsociarElemento = true;
		this.hidePosicionarElemento = true;
		this.hideAudioguia = true;
		this.hideModelo3d = true;
		this.displayDialogPosicion = false;
	}

//#endregion

//#region  --  CARGAR DATOS --

	obtenerEntyties(){
		const includes = 'IDIOMAS';
		const where = undefined;
		const that = this;
		const promises = [];
		promises.push(this.obtenerESPACIO(where, includes));
		promises.push(this.obtenerALA());
		promises.push(this.obtenerNODO(where, includes));
		promises.push(this.obtenerSECCION(where, includes));
		that.spinner.style.display = 'inherit';
		return allSettled(promises);
	}

	obtenerNODO(where, includes) {
		const that = this;
		// includes = includes + ', SECCION, CONTENIDOS.CONTENIDO.TIPOLOGIA_CONTENIDO';
		includes = includes + ', SECCION, CONTENIDOS';
		return that.entityManager.getNODO(where, includes)
		.then(function (entidades) {
			that.listaNodos = [];
			entidades.sort((a, b) => (a.Nombre > b.Nombre) ? 1 : -1);
			entidades.forEach(element => {
				const nodo = new NodoFormulario().fromENTIDAD(element);
				that.listaEntidades.push(nodo);
				that.listaNodos.push(nodo);
			});
		});
	}

	obtenerALA() {
		const that = this;
		const entityManager = that.entityManager;

		// let includes = 'SECCIONS, SECCIONS.NODOS.IDIOMAS, SECCIONS.IDIOMAS';
		let includes = 'SECCIONS, SECCIONS.NODOS';

		includes = includes + ', NIVEL';
		return entityManager.getALA(undefined, includes)
		.then(function (entidades) {
			if (entidades == null || entidades.length < 1) {
				console.log('NO HAY ALAS');
			}
			else {
				that.listaAlas = [];

				//entidades.sort((a, b) => (a.Nomobre > b.Nomobre) ? 1 : -1);
				entidades.sort( function(a, b) {
						if ( a.NIVEL.NivelVertical === b.NIVEL.NivelVertical) {
						  return a.Nomobre.localeCompare(b.Nomobre) ;
						}
						return a.NIVEL.NivelVertical - b.NIVEL.NivelVertical;
					  });
				entidades.forEach(element => {
					const ala = new AlaFormulario(element);
					that.listaEntidades.push(ala);
					that.listaEntidadesDestacar.push(ala);
					that.listaAlas.push(ala);

				});


			}
		});
	}

	obtenerESPACIO(where, includes) {
		const that = this;
		const idEspacio = this.authService.getIdEspacio();
		where = new Predicate('Id', '==', idEspacio);
		return that.entityManager.getESPACIO(where, includes)
		.then(function (entidades) {
			that.listaEspacios = [];
			entidades.sort((a, b) => (a.Nombre > b.Nombre) ? 1 : -1);
			entidades.forEach(element => {
				const espacio = new EspacioFormulario(element);
				that.listaEntidades.push(espacio);
				that.listaEntidadesDestacar.push(espacio);
				that.listaEspacios.push(espacio);
			});
		});
	}

	obtenerSECCION(where, includes) {
		const that = this;
		return that.entityManager.getSECCION(where, includes)
		.then(function (entidades) {
			that.listaSecciones = [];
			entidades.sort((a, b) => (a.Nombre > b.Nombre) ? 1 : -1);
			entidades.forEach(element => {
				const seccion = new SeccionFormulario().fromENTIDAD(element);
				that.listaEntidades.push(seccion);
				that.listaEntidadesDestacar.push(seccion);
				that.listaSecciones.push(seccion);
			});
		});
	}
//#endregion

//#region -- GUARDAR CONTENIDO --

	onSubmit() {
		const a = 1;
		this.guardarContenido();
	}

	validateAllFormFields(formGroup: FormGroup) {         // {1}
		Object.keys(formGroup.controls).forEach(field => {  // {2}
			const control = formGroup.get(field);             // {3}
			if (control instanceof FormControl) {             // {4}
				control.markAsDirty();
				control.markAsTouched({ onlySelf: true });
			} else if (control instanceof FormGroup) {        // {5}
				this.validateAllFormFields(control);            // {6}
			}
		});
	}


	guardar(){
		const that = this;
		this.confirmationService.confirm({
			message: this.translate.instant('MensajesConfirmacion.MENSAJE_CONFIRMACION_MODIFICAR'),
			accept: () => {

				// Mostramos Spinner
				this.spinner.style.display = 'inherit';
				return this.guardarContenido()
				.then(function(resp){
					console.log(resp)
					// Ocultamos Spinner
					// that.spinner.style.display = 'none';
					if ( resp ){
						that.appComponent.showSuccess( that.translate.instant('MensajesConfirmacion.MENSAJE_SUCCES'));
						//this.srcNuevaImagenDetalle = '';
						that.router.navigate(['/contenidos']);
						console.log(resp)
					}
					else{
						// Ocultamos Spinner
						that.spinner.style.display = 'none';
					}
					})
					.catch(function(e){
					// Ocultamos Spinner
					that.spinner.style.display = 'none';
					});
			},
			reject: () => {
				console.log('Cancelado el Guardado de Contenido.');
			}
		});


	}

	cancelar(){
		this.confirmationService.confirm({
            message: this.translate.instant('MensajesConfirmacion.MENSAJE_CONFIRMACION_CANCELAR'),
            accept: () => {
				this.router.navigate(['/contenidos']);
			},
			reject: () => {
				console.log('Cancelado el Cancelado de Contenido.');
			}
        });
	}

	volver(){
		this.router.navigate(['/contenidos']);
	}

	guardarContenido() {
		if (this.validarFormularioContenido()) {

			const that = this;
			const token = that.authService.getToken();
			const idEspacio = that.authService.getIdEspacio();

			if(this.contenidoSeleccionado.IdAlternativo === "" || this.contenidoSeleccionado.IdAlternativo === null){
				if (!that.esEdicion) {
					return that.guardarNuevoContenido();
				}
				else {
					return that.guardarEdicionContenido();
				}
			}
			else{
				return this.sws.wsValidarIdAlternativoContenidos(token, idEspacio, this.contenidoSeleccionado.IdAlternativo).toPromise()
				.then(function (resp) {
					// TODO: resp.existe y no pertenece al this.contenidoSeleccionado (this.contenidoSeleccionado.Id o esta en res.lista)
					if (resp.res > 0 ) {
						if (!that.esEdicion) {
							if (!resp.existe) {
								return that.guardarNuevoContenido();
							}
							else{
								// TODO: Avisar que ya existe
								console.log(resp);
								that.appComponent.showError(that.translate.instant('MensajesConfirmacion.MENSAJE_CONTENIDO_IDALTERNATIVO_REPETIDO'));

							}
						}
						else {
							if (!resp.existe || (resp.existe && resp.lista.indexOf( that.contenidoSeleccionado.Id ) >= 0 )) {
								return that.guardarEdicionContenido();
							}
							else{
								// TODO: Avisar que ya existe
								console.log(resp);
								that.appComponent.showError(that.translate.instant('MensajesConfirmacion.MENSAJE_CONTENIDO_IDALTERNATIVO_REPETIDO'));
							}
						}
					}
					else{
						// TODO: hubo un error al validar el contenido
						console.log(resp);
						that.appComponent.showError(that.translate.instant('MensajesConfirmacion.MENSAJE_CONTENIDO_IDALTERNATIVO_REPETIDO'));

					}
				});
			}

		} else {
			return Promise.resolve(false);
		}
	}

	validarIdAlternativ(){

	}

	/* Validar */
	inputChanged(value) {

		const p1Error = this.contenidoSeleccionado.Titulo === '' || this.contenidoSeleccionado.Titulo === undefined;
		const p2Error = this.contenidoSeleccionado.FechaAlta == null || this.contenidoSeleccionado.FechaAlta === undefined;
		const p3Error = false; // this.contenidoSeleccionado.FechaBaja === ''  || this.contenidoSeleccionado.FechaBaja === undefined  || this.contenidoSeleccionado.FechaBaja === null;
		const p4Error = this.contenidoSeleccionado.Imagen === undefined && this.contenidoSeleccionado === undefined;

		// Validacion al guardar
		if (value === 'obligatorio'){
			if (p1Error) {
				this.tituloError = true;
			}
			else {
				this.tituloError = false;
			}

			if (p2Error) {
				this.fAltaError = true;
			}
			else {
				this.fAltaError = false;
			}

			if (p3Error) {
				this.fBajaError = true;
			}
			else {
				this.fBajaError = false;
			}

			if (p4Error) {
				this.imagenError = true;
			}
			else {
				this.imagenError = false;
			}
		}
		// validacion al editar titulo
		else if (value === 'titulo'){
			if (p1Error) {
				this.tituloError = true;
			}
			else {
				this.tituloError = false;
			}
		}
		// validacion al editar fecha_alta
		else if (value === 'fecha_alta'){
			if (p2Error) {
				this.fAltaError = true;
			}
			else {
				this.fAltaError = false;
			}
		}
		// validacion al editar fecha_baja
		else if (value === 'fecha_baja'){
			if (p3Error) {
				this.fBajaError = true;
			}
			else {
				this.fBajaError = false;
			}
		}

		try {
			//  Cojemos la traduccion del contenido al idioma seleccionado
			const contenidoIdioma = this.contenidoSeleccionado.Idiomas.get(this.idiomaSeleccionado.ENTIDAD.Codigo);

			// Guardamos los posibles cambios del idioma
			contenidoIdioma.Nombre = this.contenidoSeleccionado.Titulo;
			contenidoIdioma.Descripcion = this.contenidoSeleccionado.Descripcion;
			contenidoIdioma.htmlVisualizableDetalle = this.contenidoSeleccionado.HtmlDetalle;
			contenidoIdioma.AudioTexto = this.contenidoSeleccionado.AudioTexto;
			contenidoIdioma.NombreCorto = this.contenidoSeleccionado.NombreCorto;
		} catch (error) {

		}

	}

	public validarFormularioContenido(): boolean {
		this.inputChanged('obligatorio');

		const p1 = this.tituloError;
		const p2 = this.fAltaError;
		const p3 = this.fBajaError;
		const p4 = this.imagenError;
		const p5 = this.listaSeleccionados.length <= 0;
		const p6 = this.listaNodosSeleccionados.length <= 0 || this.contenidoSeleccionado.ALA_PLANO === null;

		if (p1 || p2 || p3 || p4 || p5 || p6) {
			this.isValid = false;
			if (p4) {
				if (this.imagenError) {
					this.msgs.push({severity: 'error', summary: 'Imagen obligatoria', detail: this.translate.instant('Contenidos.imagenobligatorialabel')});
				}
			}
			if (p5) {
				this.appComponent.showError(this.translate.instant('MensajesConfirmacion.MENSAJE_CONTENIDO_NO_ASIGNADO'));
				console.log(this.translate.instant('MensajesConfirmacion.MENSAJE_CONTENIDO_NO_ASIGNADO'));
			}
			if (p6){
				this.appComponent.showError(this.translate.instant('MensajesConfirmacion.MENSAJE_CONTENIDO_NODO_NO_ASIGNADO'));
				console.log(this.translate.instant('MensajesConfirmacion.MENSAJE_CONTENIDO_NODO_NO_ASIGNADO'));
			}

			else {
				this.appComponent.showError(this.translate.instant('MensajesConfirmacion.MENSAJE_FORMULARIO_NO_VALIDO'));
				console.log(this.translate.instant('MensajesConfirmacion.MENSAJE_FORMULARIO_NO_VALIDO'));
			}
		}
		else {
			this.isValid = true;
		}

		return this.isValid;
	}

	guardarEdicionContenido() {
		const that = this;

		return this.guardarMultiIdioma()
		.then(function(){
			return that.createOrUpdateWebs();
		})
		.then(function () {
			return that.crearRelaciones(that.listaSeleccionados);
		})
		.then(function () {
			return that.subirFotos();
		})
		.then(function (datos) {
			return that.actualizarFotosConDetalle(datos);
		})
		.then(function(){
			return that.subirFotosCarrousel();
		})
		.then(function(datos){
			console.log(datos)
			return that.actualizarFotosCarrousel(datos);
		})
		.then(function (resp) {
			//that.contenidoSeleccionado.ENTIDAD.FOTOS = that.contenidoSeleccionado.ENTIDAD.FOTOS.filter( f => resp.lista.find(fc => fc.Id == f.Id));

			console.log("MODELO_3D chack Nombre: " + that.modeloSeleccionado.Nombre);
			console.log("MODELO_3D chack Descripcion: " + that.modeloSeleccionado.Descripcion);
			console.log("MODELO_3D chack Fecha Alta: " + that.modeloSeleccionado.FechaAlta);
			console.log("MODELO_3D chack ios: " + that.urlModeloSeleccionado_ios);
			console.log("MODELO_3D chack android: " + that.urlModeloSeleccionado_android);
			// Solo creo una entrada de MODELO_3D en Base de datos si se ha rellenado algun campo de la parte de formulario MODELO_3D
			if (that.modeloSeleccionado.Nombre !== '' || that.modeloSeleccionado.Descripcion !== '' || that.urlModeloSeleccionado_ios !== undefined || that.urlModeloSeleccionado_android !== undefined) {
				return that.guardarModelo();
			}
			else {
				return true;
			}
		})
		.then(function () {
			const token = that.authService.getToken();
			const idEspacio = that.authService.getIdEspacio();
			const idAla =  that.contenidoSeleccionado.ALA_PLANO.Id;

			return that.sws.wsObtenerLLFromXY(token, that.contenidoSeleccionado.X, that.contenidoSeleccionado.Y, idEspacio, idAla).toPromise();
		})
		.then(function (ll) {
			that.contenidoSeleccionado.ENTIDAD.Latitud = ll.Latitud;
			that.contenidoSeleccionado.ENTIDAD.Longitud = ll.Longitud;
			return that.entityManager.saveChanges();
		})
		.then(function(){

			// Comprobar si Tipologia seleccionada es TipoUbicacion = Constantes.TIPO_LOCALIZACION_ACTIVOS.DIRECTA
			// Si no es localizable ELIMINAMOS TODAS LAS RELACIONES USUARIO_has_CONTENIDO_has_BALIZA con idContenido == that.contenidoSeleccionado.Id
			// Sino Return true;
			const token = that.authService.getToken();
			const idEspacio = that.authService.getIdEspacio();
			const tipologia = that.contenidoSeleccionado.TIPOLOGIA_CONTENIDO;

			if (tipologia !== undefined && tipologia !== null) {
				if (tipologia.TipoUbicacion === 'ESTATICO' || tipologia.TipoUbicacion === null){
					return that.sws.wsBorrarRelacionTipologiaNoLocalizable(token, that.contenidoSeleccionado.Id, idEspacio).toPromise();
				}
			}


		})
		.then(function () {
			console.log('Guardada Edicion contenido.');
			that.appComponent.showSuccess(that.translate.instant('Contenidos.guardaredicioncontenido'));
			return true;
		})
		.catch(function (e) {
			that.entityManager.RejectChanges();
			that.appComponent.showError(e.message);
			return false;
		});
	}

	guardarMultiIdioma(){
		const that = this;

		// Seteamos los Campos por defecto con el valor del Idioma por defecto
		const contenidoIdioma = that.contenidoSeleccionado.Idiomas.get(that.idiomaDefecto.ENTIDAD.Codigo);
		this.contenidoSeleccionado.Titulo = contenidoIdioma ? contenidoIdioma.Nombre : '';
		this.contenidoSeleccionado.Descripcion = contenidoIdioma ? contenidoIdioma.Descripcion : '';
		this.contenidoSeleccionado.HtmlDetalle = contenidoIdioma ? contenidoIdioma.htmlVisualizableDetalle : '';
		this.contenidoSeleccionado.AudioTexto = contenidoIdioma ? contenidoIdioma.AudioTexto : '';
		this.contenidoSeleccionado.NombreCorto = contenidoIdioma ? contenidoIdioma.NombreCorto : '';

		this.contenidoSeleccionado.ENTIDAD.Titulo = this.contenidoSeleccionado.Titulo;
		this.contenidoSeleccionado.ENTIDAD.Descripcion = this.contenidoSeleccionado.Descripcion;
		this.contenidoSeleccionado.ENTIDAD.FechaAlta = this.contenidoSeleccionado.FechaAlta;
		this.contenidoSeleccionado.ENTIDAD.FechaBaja = this.contenidoSeleccionado.FechaBaja;
		this.contenidoSeleccionado.ENTIDAD.htmlVisualizableDetalle = this.contenidoSeleccionado.HtmlDetalle;
		this.contenidoSeleccionado.ENTIDAD.TIPOLOGIA_CONTENIDO = this.contenidoSeleccionado.TIPOLOGIA_CONTENIDO;
		this.contenidoSeleccionado.ENTIDAD.AudioTexto = this.contenidoSeleccionado.AudioTexto;
		this.contenidoSeleccionado.ENTIDAD.NombreCorto = this.contenidoSeleccionado.NombreCorto;
		this.contenidoSeleccionado.ENTIDAD.IdAlternativo = this.contenidoSeleccionado.IdAlternativo;

		this.entityManager.deleteEntityArray(this.contenidoSeleccionado.ENTIDAD.IDIOMAS);

		return this.entityManager.newCONTENIDO_IDIOMA(this.contenidoSeleccionado.ENTIDAD)
		.then(function(CONTENIDO_IDIOMAs){

			CONTENIDO_IDIOMAs.forEach(CONTENIDO_IDIOMA => {
				// if (CONTENIDO_IDIOMA.constructor.name.indexOf('CONTENIDO_IDIOMA') >= 0) {
				const aux = that.contenidoSeleccionado.Idiomas.get(CONTENIDO_IDIOMA.IDIOMA.Codigo);
				if (aux) {
					CONTENIDO_IDIOMA.Nombre = aux.Nombre ? aux.Nombre : '';
					CONTENIDO_IDIOMA.Descripcion = aux.Descripcion ? aux.Descripcion : '';
					CONTENIDO_IDIOMA.htmlVisualizableDetalle = aux.htmlVisualizableDetalle ? aux.htmlVisualizableDetalle : '';
					CONTENIDO_IDIOMA.AudioTexto = aux.AudioTexto ? aux.AudioTexto : '';
					CONTENIDO_IDIOMA.NombreCorto = aux.NombreCorto ? aux.NombreCorto : '';
				}
			});
			return that.guardarDescripcionSinFoto(that.contenidoSeleccionado.ENTIDAD);
		});
	}

	public subirFotos() {

		const promises: any[] = [];
		const that = this;

		if (that.contenidoSeleccionado.nuevaImagenSeleccionada) {
			/*
			if (that.contenidoSeleccionado.ENTIDAD && that.contenidoSeleccionado.ENTIDAD.FOTOS) {
				that.entityManager.deleteEntityArray(that.contenidoSeleccionado.ENTIDAD.FOTOS);
			}
			*/

			let idFoto = null;
			if (that.contenidoSeleccionado.ENTIDAD && that.contenidoSeleccionado.ENTIDAD.FOTOS) {
				const ultima = that.contenidoSeleccionado.ENTIDAD.FOTOS.length - 1;
				const fotoUpdate = that.contenidoSeleccionado.ENTIDAD.FOTOS[ultima];
				idFoto = fotoUpdate ? fotoUpdate.Id : null;
			}
			promises.push(that.enviarFoto('IdContenido', that.contenidoSeleccionado.ENTIDAD.Id, that.contenidoSeleccionado.nuevaImagenSeleccionada, idFoto));
		}

		return allSettled(promises);
	}

	public actualizarFotosConDetalle(data){
		
		const promises: any[] = [];
		const that = this;
		let idFoto = null;
		let includes = 'FOTOS';
		let Id = that.contenidoSeleccionado.ENTIDAD.Id;
		console.log(that.contenidoSeleccionado)
		this.entityManager.getContenidoById(Id, includes)
		.then(function (contenido) {
			if (contenido && contenido.length > 0) {
				const fotoUpdate = contenido[0].FOTOS.find(f => f.Tipo === Constantes.TIPO_FOTO.PRINCIPAL)
				idFoto = fotoUpdate ? fotoUpdate.Id : null;

				if (that.contenidoSeleccionado.nuevaImagenDetalleSeleccionada) {
					promises.push(that.actualizarFotoDetalle('IdContenido', that.contenidoSeleccionado.ENTIDAD.Id, that.contenidoSeleccionado.nuevaImagenDetalleSeleccionada, idFoto));
				}
				if (that.contenidoSeleccionado.borrarImagenDetalleSeleccionada) {
					promises.push(that.borrarFotoDetalle('IdContenido', that.contenidoSeleccionado.ENTIDAD.Id, that.contenidoSeleccionado.borrarImagenDetalleSeleccionada));
				}
			}
		})
		.catch(function (err){
			console.log('errorFotoDetalle: ' + err.status);
			that.appComponent.showError(err.toString());
		});

		return allSettled(promises);


	}

	public subirFotosCarrousel(){

		const that = this;
		if(that.fotosCarrusel && that.fotosCarrusel.length > 0){
			let auxArrayFotosSubir = that.fotosCarrusel.filter(foto => foto.Id === 'undefined');
			if(auxArrayFotosSubir.length > 0){
				let ficherosSubir = [];
				auxArrayFotosSubir.forEach(element =>{
					ficherosSubir.push(element.File);
				})
				return this.sws.subirFotosCMS(ficherosSubir);
			}
		}





	}
	public actualizarFotosCarrousel(nuevasFotos){

		nuevasFotos = typeof nuevasFotos === 'undefined' ? [] : nuevasFotos;
		console.log(nuevasFotos)
		if(nuevasFotos.length > 0){

			for (let i = 0; i < nuevasFotos.length; i++) {
				let index = this.fotosCarrusel.findIndex(f => f.Id === 'undefined');
				this.fotosCarrusel[index].UrlFotoExt = nuevasFotos[i].UrlFotoExt;
				this.fotosCarrusel[index].UrlFotoExt_detalle = nuevasFotos[i].UrlFotoExt;
				this.fotosCarrusel[index].IdFotoExt = nuevasFotos[i].IdFotoExt;
				this.fotosCarrusel[index].IdFotoExt_detalle = nuevasFotos[i].IdFotoExt;
				this.fotosCarrusel[index].Id = null;
				this.fotosCarrusel[index].IdContenido = this.contenidoSeleccionado.ENTIDAD.Id;

			}


		}
		console.log(this.fotosCarrusel);

		const token = this.authService.getToken();
		return this.sws.wsActualizarFotosCarrusel(token, this.contenidoSeleccionado.ENTIDAD.Id, this.fotosCarrusel, '').toPromise();
	}
	botonBorrarFotoDetallePresionado(){
		console.log(this.contenidoSeleccionado.ImagenDetalle);
		this. contenidoSeleccionado.borrarImagenDetalleSeleccionada = true;
		if(this.contenidoSeleccionado.nuevaImagenDetalleSeleccionada){
			this.contenidoSeleccionado.nuevaImagenDetalleSeleccionada = null;
		}
		else if(this.contenidoSeleccionado.ImagenDetalle && !this.contenidoSeleccionado.nuevaImagenDetalleSeleccionada){
			this.contenidoSeleccionado.ImagenDetalle = null;
		}
		else{
			this. contenidoSeleccionado.borrarImagenDetalleSeleccionada = false;
		}
	}
	guardarMultiIdiomaWebs(){
		const that = this;

		that.contenidoSeleccionado.WebsExternas.forEach(webExterna => {
			// Si webExterna no tiene ENTIDAD es que es Nueva por lo que la creamos
			if (webExterna.ENTIDAD) {
				this.entityManager.deleteEntityArray(this.contenidoSeleccionado.ENTIDAD.IDIOMAS);
				this.entityManager.newCONTENIDO_WEB_EXTERNA_IDIOMA(this.contenidoSeleccionado.ENTIDAD)
				.then(function(CONTENIDO_IDIOMAs){

					CONTENIDO_IDIOMAs.forEach(CONTENIDO_IDIOMA => {
						const aux = webExterna.Idiomas.get(CONTENIDO_IDIOMA.IDIOMA.Codigo);
						if (aux) {
							CONTENIDO_IDIOMA.Texto = aux.Texto;
							CONTENIDO_IDIOMA.Codigo = aux.Codigo;
						}

					});

				});
			}
		});
	}


	eliminarRelaciones(){
		this.contenidoSeleccionado.ENTIDAD.ALAS.forEach(ENTIDAD => {
			this.listaRelacionesEliminadas.push(ENTIDAD);
		});
		try {
			this.entityManager.deleteEntityArray(this.contenidoSeleccionado.ENTIDAD.ALAS);

		} catch (error) {
			console.error('ERROR: al borrar relaciones con ala: ' + error);
		}

		this.contenidoSeleccionado.ENTIDAD.ESPACIOS.forEach(ENTIDAD => {
			this.listaRelacionesEliminadas.push(ENTIDAD);
		});
		try {
			this.entityManager.deleteEntityArray(this.contenidoSeleccionado.ENTIDAD.ESPACIOS);

		} catch (error) {
			console.error('ERROR: al borrar relaciones con ala: ' + error);
		}

		this.contenidoSeleccionado.ENTIDAD.SECCIONES.forEach(ENTIDAD => {
			this.listaRelacionesEliminadas.push(ENTIDAD);
		});
		try {
			this.entityManager.deleteEntityArray(this.contenidoSeleccionado.ENTIDAD.SECCIONES);

		} catch (error) {
			console.error('ERROR: al borrar relaciones con ala: ' + error);
		}

		this.contenidoSeleccionado.ENTIDAD.NODODS.forEach(ENTIDAD => {
			this.listaRelacionesEliminadas.push(ENTIDAD);
		});
		try {
			this.entityManager.deleteEntityArray(this.contenidoSeleccionado.ENTIDAD.NODODS);

		} catch (error) {
			console.error('ERROR: al borrar relaciones con ala: ' + error);
		}
	}

	crearRelaciones(listaSeleccionados) {
		const that = this;
		const promises: any[] = [];

		// Eliminamos las Relaciones Actuales
		this.eliminarRelaciones();

		// Creamos las Nuevas Relaciones
		listaSeleccionados.forEach(element => {
			if (element.TIPO === 'ESPACIO') {
				promises.push(this.entityManager.newESPACIO_has_CONTENIDO());
			} else if (element.TIPO === 'ALA') {
				promises.push(this.entityManager.newALA_has_CONTENIDO());
			} else if (element.TIPO === 'SECCION') {
				promises.push(this.entityManager.newSECCION_has_CONTENIDO());
			} else if (element.TIPO === 'NODO') {
				promises.push(this.entityManager.newNODO_has_CONTENIDO());
			}
		});

		// resolvemos todos los promises del array
		return allSettled(promises)
		.then(function (datos) {

			if (datos.length === that.listaSeleccionados.length) {
				for (let index = 0; index < that.listaSeleccionados.length; index++) {
					const seleccionado = that.listaSeleccionados[index];
					const element = datos[index].result;

					if (element.constructor.name.indexOf('ESPACIO_has_CONTENIDO') >= 0) {
						const relacionAntigua = that.listaRelacionesEliminadas.filter( x => x.IdEspacio === seleccionado.ENTIDAD.Id)[0];
						element.CONTENIDO = that.contenidoSeleccionado.ENTIDAD;
						element.IdContenido = that.contenidoSeleccionado.ENTIDAD.Id;
						element.ESPACIO = seleccionado.ENTIDAD;
						element.IdEspacio = seleccionado.ENTIDAD.Id;
						element.Prioridad = relacionAntigua ? relacionAntigua.Prioridad : element.ESPACIO.CONTENIDOS.length;
						element.PrioridadDestacado = relacionAntigua ? relacionAntigua.PrioridadDestacado : 0;
					} else if (element.constructor.name.indexOf('ALA_has_CONTENIDO') >= 0) {
						const relacionAntigua = that.listaRelacionesEliminadas.filter( x => x.IdAla === seleccionado.ENTIDAD.Id)[0];
						element.CONTENIDO = that.contenidoSeleccionado.ENTIDAD;
						element.IdContenido = that.contenidoSeleccionado.ENTIDAD.Id;
						element.ALA = seleccionado.ENTIDAD;
						element.IdAla = seleccionado.ENTIDAD.Id;
						element.Prioridad = relacionAntigua ? relacionAntigua.Prioridad : element.ALA.CONTENIDOS.length;
						element.PrioridadDestacado = relacionAntigua ? relacionAntigua.PrioridadDestacado : 0;
					} else if (element.constructor.name.indexOf('SECCION_has_CONTENIDO') >= 0) {
						const relacionAntigua = that.listaRelacionesEliminadas.filter( x => x.IdSeccion === seleccionado.ENTIDAD.Id)[0];
						element.CONTENIDO = that.contenidoSeleccionado.ENTIDAD;
						element.IdContenido = that.contenidoSeleccionado.ENTIDAD.Id;
						element.SECCION = seleccionado.ENTIDAD;
						element.IdSeccion = seleccionado.ENTIDAD.Id;
						element.Prioridad = relacionAntigua ? relacionAntigua.Prioridad : element.SECCION.CONTENIDOS.length;
						element.PrioridadDestacado = relacionAntigua ? relacionAntigua.PrioridadDestacado : 0;
					}
					else if (element.constructor.name.indexOf('NODO_has_CONTENIDO') >= 0) {
						element.CONTENIDO = that.contenidoSeleccionado.ENTIDAD;
						element.IdContenido = that.contenidoSeleccionado.ENTIDAD.Id;
						element.NODO = seleccionado.ENTIDAD;
						element.IdNodo = seleccionado.ENTIDAD.Id;
					}
				}

				return datos;
			}
			else {
				this.appComponent.showError(that.translate.instant('Contenidos.errorcreandocontenidos'));
				console.log('Error - No se crearon correctamente todas las relaciones de Contenido con las entidades');
			}
		});
	}

	guardarNuevoContenido() {
		console.log('aqui');
		const that = this;

		// Creamos nuevo contenido
		return this.entityManager.newCONTENIDO()
		.then(function (oCONTENIDO) {

			const contenidoIdioma = that.contenidoSeleccionado.Idiomas.get(that.idiomaDefecto.ENTIDAD.Codigo);
			that.contenidoSeleccionado.Titulo = contenidoIdioma.Nombre ? contenidoIdioma.Nombre : '';
			that.contenidoSeleccionado.Descripcion = contenidoIdioma.Descripcion ? contenidoIdioma.Descripcion : '';
			that.contenidoSeleccionado.HtmlDetalle = contenidoIdioma.htmlVisualizableDetalle ? contenidoIdioma.htmlVisualizableDetalle : '';
			that.contenidoSeleccionado.AudioTexto = contenidoIdioma.AudioTexto ? contenidoIdioma.AudioTexto : '';
			that.contenidoSeleccionado.NombreCorto = contenidoIdioma.NombreCorto ? contenidoIdioma.NombreCorto : '';

			oCONTENIDO.Titulo = that.contenidoSeleccionado.Titulo;
			oCONTENIDO.Descripcion = that.contenidoSeleccionado.Descripcion;
			oCONTENIDO.htmlVisualizableDetalle = that.contenidoSeleccionado.HtmlDetalle;
			oCONTENIDO.FechaAlta = that.contenidoSeleccionado.FechaAlta;
			oCONTENIDO.FechaBaja = that.contenidoSeleccionado.FechaBaja;
			oCONTENIDO.EspacioPertenencia = that.authService.getIdEspacio();
			oCONTENIDO.ALA_PLANO = that.contenidoSeleccionado.ALA_PLANO.ENTIDAD;
			oCONTENIDO.X = that.contenidoSeleccionado.X;
			oCONTENIDO.Y = that.contenidoSeleccionado.Y;
			oCONTENIDO.AudioTexto = that.contenidoSeleccionado.AudioTexto;
			oCONTENIDO.IdAlternativo = that.contenidoSeleccionado.IdAlternativo;
			oCONTENIDO.NombreCorto = that.contenidoSeleccionado.NombreCorto;

			that.contenidoSeleccionado.ENTIDAD = oCONTENIDO;

			let tipologia = that.contenidoSeleccionado.TIPOLOGIA_CONTENIDO;

			if ((tipologia === undefined || tipologia === null) && that.tipologiasContenido.length > 0) {
				tipologia = that.tipologiasContenido[0];
			}

			oCONTENIDO.TIPOLOGIA_CONTENIDO = tipologia;

			oCONTENIDO.IDIOMAS.forEach(CONTENIDO_IDIOMA => {
				const aux = that.contenidoSeleccionado.Idiomas.get(CONTENIDO_IDIOMA.IDIOMA.Codigo);
				if (aux) {
					CONTENIDO_IDIOMA.Nombre = aux.Nombre;
					CONTENIDO_IDIOMA.Descripcion = aux.Descripcion;
					CONTENIDO_IDIOMA.htmlVisualizableDetalle = aux.htmlVisualizableDetalle;
					CONTENIDO_IDIOMA.AudioTexto = aux.AudioTexto;
					CONTENIDO_IDIOMA.NombreCorto = aux.NombreCorto;
				}
			});

			return that.crearRelaciones(that.listaSeleccionados);
		})
		.then(function (datos) {
			const token = that.authService.getToken();
			const idEspacio = that.authService.getIdEspacio();
			const idAla =  that.contenidoSeleccionado.ALA_PLANO.Id;

			return that.sws.wsObtenerLLFromXY(token, that.contenidoSeleccionado.X, that.contenidoSeleccionado.Y, idEspacio, idAla).toPromise();
		})
		.then(function (ll) {
			that.contenidoSeleccionado.ENTIDAD.Latitud = ll.Latitud;
			that.contenidoSeleccionado.ENTIDAD.Longitud = ll.Longitud;

			return that.guardarDescripcionSinFoto(that.contenidoSeleccionado.ENTIDAD);
		})
		.then(function (datos) {
			return that.entityManager.saveChanges();
		})
		.then(function (datos) {
			return that.subirFotos();
		})
		.then(function (datos) {
			console.log('aqui')
			return that.actualizarFotosConDetalle(datos);
		})
		.then(function(){
			return that.subirFotosCarrousel();
		})
		.then(function(datos){
			console.log(datos)
			return that.actualizarFotosCarrousel(datos);
		})
		.then(function (datos) {
			return that.guardarModelo();
		})
		.then(function (datos) {
			console.log('FOTO ok');
			return that.createOrUpdateWebs();
		})
		.then(function (datos) {
			console.log('WEBS ok');
			return true;
		})
		.catch(function (e) {

			that.appComponent.showError(e.message);
			return false;
		});
	}

	// Guarda las descripciones en todos los idiomas sustituyendo el base64 de als imagenes por enlaces de descarga
	guardarDescripcionSinFoto(CONTENIDO: any){
		const promises: any[] = [];
		const that = this;
		let IDIOMAS;

		IDIOMAS = CONTENIDO.IDIOMAS;
		CONTENIDO.IDIOMAS.forEach(CONTENIDO_IDIOMA => {
			promises.push(that.sws.subirFicherosFromHTML(CONTENIDO_IDIOMA.htmlVisualizableDetalle));
		});

		return allSettled(promises)
		.then((urls) => {
			// urls trae un array por idioma, en el mismo orden que se generola llamada
			for (let index = 0; index < CONTENIDO.IDIOMAS.length; index++) {

				const CONTENIDO_IDIOMA = CONTENIDO.IDIOMAS[index];
				const fotosUrl = urls[index].result;
				let htmlDetalleSinImagenes = CONTENIDO_IDIOMA.htmlVisualizableDetalle ;
				// Cogemos las fotos de este idioma
				const arraySRCs =	that.sws.getImgSrcFromHTML(CONTENIDO_IDIOMA.htmlVisualizableDetalle);
				// TODO: reemplazar los base64 de CONTENIDO_IDIOMA.htmlVisualizableDetalle por los enlaces en urls y meterlo en htmlDetalleSinImagenes
				for (let index2 = 0; index2 < arraySRCs.length; index2++) {
					const src = arraySRCs[index2];
					const fotourl =  fotosUrl[index2];
					htmlDetalleSinImagenes = htmlDetalleSinImagenes.toString().replace(src, fotourl);
				}
				CONTENIDO_IDIOMA.htmlVisualizableDetalle = htmlDetalleSinImagenes;
				CONTENIDO_IDIOMA.Nombre =  CONTENIDO_IDIOMA.Nombre ? CONTENIDO_IDIOMA.Nombre : '';

				// Si es el idioma por defecto tambien cambiamos en CONTENIDO
				that.idiomaDefecto = that.idiomaService.getIdiomaDefecto(that.idiomas);
				if (that.idiomaDefecto.ENTIDAD.Id === CONTENIDO_IDIOMA.IdIdioma) {
					CONTENIDO.htmlVisualizableDetalle = htmlDetalleSinImagenes;
				}
			}
			return CONTENIDO.IDIOMAS;
		}).catch((err) => {
			console.log(err);
		});
	}

	enviarFoto(entidad, idEntidad, imagen, idFoto = null) {
		const token = this.authService.getToken();
		if (imagen !== undefined) {
			return this.sws.wsSubidaFoto(token, entidad, idEntidad, imagen, imagen.name, idFoto).toPromise();
		}
	}

	actualizarFotoDetalle(entidad, idEntidad, imagen, idFoto) {
		const token = this.authService.getToken();
		if (imagen !== undefined) {
			return this.sws.wsActualizarFotoConDetalle(token, entidad, idEntidad, imagen, imagen.name, idFoto).toPromise();
		}

	}
	borrarFotoDetalle(entidad, idEntidad, imagen){
		console.log("se va a eliminar la foto detalle");
		const token = this.authService.getToken();
		if(imagen !== undefined){
			return this.sws.wsBorrarFotoConDetalle(token, entidad, idEntidad, imagen, imagen.name).toPromise();
		}
	}

//#endregion

//#region -- WEBS EXTERNAS --

createOrUpdateWebs() {
	const that = this;
	const promisesWebs: any[] = [];

	that.contenidoSeleccionado.WebsExternas.forEach(webExterna => {
		// Si webExterna no tiene ENTIDAD es que es Nueva por lo que la creamos
		if (!webExterna.ENTIDAD) {
			promisesWebs.push(that.entityManager.newCONTENIDO_WEB_EXTERNA());
		}
	});

	return allSettled(promisesWebs) // resolvemos todos los promises del array para crear nuevas webs
	.then(function (contenido_web_externas) {
		const promisesWebsIdioma: any[] = [];
		// webExterna.ENTIDAD == [] si no hay webs nuevas
		for (let index = 0; index < that.contenidoSeleccionado.WebsExternas.length; index++) {
			const webExterna = that.contenidoSeleccionado.WebsExternas[index];

			// Si webExterna.ENTIDAD == undefined -> hay webs nuevas, por lo contenido_web_externas traera las nuevas webs y las setearemos
			if (!webExterna.ENTIDAD) {
				const result = contenido_web_externas.shift();
				webExterna.ENTIDAD = result.result;
			}
			else{
				webExterna.ENTIDAD.IdWebExterna = webExterna.IdWebExterna;
			}

			webExterna.ENTIDAD.Texto = webExterna.Nombre;
			webExterna.ENTIDAD.url = webExterna.Url;

			// Texto en cada Idioma
			console.log(webExterna)
			webExterna.ENTIDAD.IDIOMAS.forEach(CONTENIDO_WEB_EXTERNA_IDIOMA => {
				console.log(CONTENIDO_WEB_EXTERNA_IDIOMA)
				const aux = webExterna.Idiomas.get(CONTENIDO_WEB_EXTERNA_IDIOMA.IDIOMA.Codigo);
				if(aux !== undefined){
					CONTENIDO_WEB_EXTERNA_IDIOMA.Texto = aux.Texto;
				}else{
					CONTENIDO_WEB_EXTERNA_IDIOMA.Texto = webExterna.Nombre;
				}
				
			});

			// Texto por defecto
			const contenidoWebExternaIdioma = webExterna.Idiomas.get(that.idiomaDefecto.ENTIDAD.Codigo);
			webExterna.Nombre = contenidoWebExternaIdioma.Texto ? contenidoWebExternaIdioma.Texto : '';
			webExterna.ENTIDAD.Nombre = webExterna.Nombre;

			that.contenidoSeleccionado.ENTIDAD.CONTENIDO_WEB_EXTERNAS.push(webExterna.ENTIDAD);

			that.entityManager.deleteEntityArray(webExterna.ENTIDAD.IDIOMAS);
			promisesWebsIdioma.push(that.entityManager.newCONTENIDO_WEB_EXTERNA_IDIOMA(webExterna.ENTIDAD));
		}
		return allSettled(promisesWebsIdioma);
	})
	.then(function(CONTENIDO_IDIOMAs){
		for (let index = 0; index < that.contenidoSeleccionado.WebsExternas.length; index++) {
			const webExterna = that.contenidoSeleccionado.WebsExternas[index];
			const result = CONTENIDO_IDIOMAs.shift();
			const CONTENIDO_WEB_EXTERNA_IDIOMAS = result.result;

			CONTENIDO_WEB_EXTERNA_IDIOMAS.forEach(CONTENIDO_WEB_EXTERNA_IDIOMA => {
				const aux = webExterna.Idiomas.get(CONTENIDO_WEB_EXTERNA_IDIOMA.IDIOMA.Codigo);
				if (aux) {
					CONTENIDO_WEB_EXTERNA_IDIOMA.Texto = aux.Texto;
					CONTENIDO_WEB_EXTERNA_IDIOMA.Codigo = aux.Codigo;
				}
			});

		}
	})
	.then(function(msg){
		return that.entityManager.saveChanges();
	})
	.then(function(msg){
		return that.contenidoSeleccionado.WebsExternas;
	})
	.catch(function(err){
		throw err;
	});
}

newWebExternaPresionado() {
	this.edicionWeb = false;
	this.WebExternaSeleccionada = new WebExterna();
	this.WebExternaSeleccionada.Idiomas = this.idiomaService.newMapContenidoWebExternaIdiomas(this.idiomas);
	this.confirmacionVisible = false;
	this.displayDialogWebExterna = true;
}

editarContenidoWebExterna(web) {
	this.edicionWeb = true;
	console.log('WEB SELECCIONADA: ' + web.Nombre);
	this.WebExternaSeleccionada = web;

	this.confirmacionVisible = false;
	this.displayDialogWebExterna = true;
}

eliminarContenidoWebExterna(webSeleccionada) {
	if (webSeleccionada.ENTIDAD) {
		this.contenidoSeleccionado.WebsExternas = this.contenidoSeleccionado.WebsExternas.filter( x => !x.ENTIDAD || (x.ENTIDAD.Id !== webSeleccionada.ENTIDAD.Id) );
		this.entityManager.deleteCONTENIDO_WEB_EXTERNA(webSeleccionada.ENTIDAD);
	}
	else{
		this.contenidoSeleccionado.WebsExternas = this.contenidoSeleccionado.WebsExternas.filter( x => x.IdWebExterna !== webSeleccionada.IdWebExterna);
	}

	this.displayDialogWebExterna = false;
}

mostrarBotonEditarWebExterna(web) {
	web.MostrarEdicion = true;
}

ocultarBotonEditarWebExterna(web) {
	web.MostrarEdicion = false;
}

onWebExternaGuardado($event){
	console.log('WEB SELECCIONADA: ' + $event.Nombre);
	this.WebExternaSeleccionada = $event;
	this.guardarContenidoWebExterna();
}

onWebExternaError($event){
	console.log('WEB SELECCIONADA: ' + $event.Nombre);
}

onWebExternaEliminado($event){
	console.log('WEB SELECCIONADA: ' + $event.Nombre);
	this.eliminarContenidoWebExterna($event);
}

guardarContenidoWebExterna() {

	if (this.edicionWeb === false) {
		this.contenidoSeleccionado.WebsExternas.push(this.WebExternaSeleccionada);
	}
	this.displayDialogWebExterna = false;
}

//#endregion

//#region  -- PLANO --
	mostrarSeleccionarAla(ala) {
		ala.seleccionarVisible = true;
	}

	ocultarSeleccionarAla(ala) {
		ala.seleccionarVisible = false;
	}

	seleccionarAla(ala: AlaFormulario) {
		this.seleccionarAlaPresionado(ala);
	}

	bloquearMapa(){
		this.msgPosicionar = [];
		this.blockUI = document.getElementsByClassName('blockPosicionarContenido')[0] as HTMLElement;
		this.blockUI.style.display = 'inherit';
		this.msgPosicionar.push({severity: 'info', detail: this.translate.instant('Contenidos.avisoDesbloquear')}); // this.translate.instant('MensajesEmergentes.MENSAJE_AVISO_SELECCIONE_NODO')
	}

	desBloquearMapa(){
		this.msgPosicionar = [];
		this.blockUI = document.getElementsByClassName('blockPosicionarContenido')[0] as HTMLElement;
		this.blockUI.style.display = 'none';
		this.msgPosicionar.push({severity: 'info', detail: this.translate.instant('Contenidos.avisoPosicionar')}); // this.translate.instant('MensajesEmergentes.MENSAJE_AVISO_SELECCIONE_NODO')
	}

	mapaBloqueadoClick(){
		this.appComponent.showWarn('mensaje', this.translate.instant('MensajesConfirmacion.MAPA_BLOQUEADO'));
	}

	seleccionarAlaPresionado(ala: AlaFormulario) {
		this.alaSeleccionada = ala;
		this.pathPlano = this.alaSeleccionada.RutaImagen;
		this.onTabClose(undefined);
	}

	/* PLANO */
	public onSVGLoaded(event) {
		this.zoomLevels = [Constantes.ZOOM_MINIMO, Constantes.ZOOM_MAXIMO];

		let contenidoPlano: ContenidoPlano;

		if (this.esEdicion ){
			if (!this.contenidoSeleccionado.ENTIDAD.X) { this.contenidoSeleccionado.ENTIDAD.X = Constantes.X_COORDENADA; }
			if (!this.contenidoSeleccionado.ENTIDAD.Y) { this.contenidoSeleccionado.ENTIDAD.Y = Constantes.Y_COORDENADA; }
			contenidoPlano = new ContenidoPlano(this.contenidoSeleccionado.ENTIDAD.Id, this.contenidoSeleccionado.ENTIDAD.Nombre, this.contenidoSeleccionado.ENTIDAD.X, this.contenidoSeleccionado.ENTIDAD.Y, '', null, this.alaSeleccionada.IconoContenidoScale);
		}
		else{
			if (!this.contenidoSeleccionado.X) { this.contenidoSeleccionado.X = Constantes.X_COORDENADA; }
			if (!this.contenidoSeleccionado.Y) { this.contenidoSeleccionado.Y = Constantes.Y_COORDENADA; }
			contenidoPlano = new ContenidoPlano('IdProbisional', this.contenidoSeleccionado.Titulo, this.contenidoSeleccionado.X, this.contenidoSeleccionado.Y, '', null, this.alaSeleccionada.IconoContenidoScale);
		}

		let tipologia = this.contenidoSeleccionado.ENTIDAD ? this.contenidoSeleccionado.ENTIDAD.TIPOLOGIA_CONTENIDO : this.contenidoSeleccionado.TIPOLOGIA_CONTENIDO;

		if ((tipologia === undefined || tipologia === null)  && this.tipologiasContenido.length > 0) {
			tipologia = this.tipologiasContenido[0];
		}

		contenidoPlano.setSimbolo(tipologia.IconoRepresentacion);
		contenidoPlano.symbolStroke = Constantes.contenidoSymbolStroke;
		contenidoPlano.symbolFill = Constantes.contenidoSymbolFill;
		contenidoPlano.symbolStrokeWidth = Constantes.contenidoSymbolStrokeWidth;
		contenidoPlano.symbolSize = Constantes.contenidoSymbolSize;

		contenidoPlano.sectionHoverFill = Constantes.contenidoSectionHoverFill;
		contenidoPlano.sectionHoverStroke = Constantes.contenidoSectionHoverStroke;
		contenidoPlano.setIconHeight(Constantes.contenidoIconHeight);
		contenidoPlano.setIconWidth(Constantes.contenidoIconWidth);

		contenidoPlano.setIconAlign(tipologia.AnchorPoint);

		if (this.contenidoSeleccionado.ALA_PLANO && this.alaSeleccionada.Id === this.contenidoSeleccionado.ALA_PLANO.Id) {
			this.contents = [contenidoPlano];
		}

		this.pintarSecciones();
	}

	public onSVGClicked($event) {
		this.appComponent.showWarn('mensaje', this.translate.instant('MensajesConfirmacion.NO_SECCION_CLICK'));
	}

	public onSeccionClicked($event){

		// Asignamos el contenido al nodo mas cercano al click realizado
		const asignado = this.asignarNodoMasCescano($event.id, $event.mp[0], $event.mp[1]);
		if ( asignado ){
			console.log('onSeccionClicked');
			this.contenidoSeleccionado.ALA_PLANO = this.alaSeleccionada;
			this.posicionarContenido($event);
		}
		else{
			this.appComponent.showWarn('mensaje', this.translate.instant('MensajesConfirmacion.NO_NODO_CERCA'));
		}
	}

	public asignarNodoMasCescano(idSeccion, x, y){
		console.log('---------------------------------');
		let seccion;
		let nodos = [];

		if (idSeccion === '') {
			seccion = this.seccionDefecto;
			nodos = seccion.NODOS;
		}
		else{
			seccion = this.mapSections.get(idSeccion);
			nodos = seccion.ENTIDAD.NODOS;
		}

		// d = sqrt( (x2 - x1)^2 + (y2 - y1)^2 )
		let distanciaMinima = Constantes.MAX_PESO;
		let nodoMasCercano;
		nodos.forEach(nodo => {
			const x1 = nodo.X;
			const y1 = nodo.Y;
			const x2 = x;
			const y2 = y;

			const d = Math.sqrt( Math.pow((x2 - x1), 2) + Math.pow((y2 - y1), 2) );
			console.log('--- Distancia a: ' + nodo.Nombre + ' = ' + d);

			// Utilizamos valores negativos para no tener que utilizar MaxValue para la inicializacion de distanciaMinima
			if (d < distanciaMinima) {
				distanciaMinima = d;
				nodoMasCercano = nodo;
			}
		});

		if (!nodoMasCercano) {
			return false;
		}
		const idNodoMasCercano = nodoMasCercano.Id;

		const entidadNodoMasCercano = this.listaEntidades.filter(obj => obj.Id === idNodoMasCercano)[0];
		this.seccionClicada = seccion.ENTIDAD;

		// Ya estaba asignado a ese nodo
		if (!entidadNodoMasCercano) {
			console.log('---  No cambia NODO mas cercza');
			return true;
		}
		else{
			// SOLO SE PERMITE ASIGNAR UN UNICO NODO AL CONTENIDO
			// NODO
			// Quito Los nodos antes asignados de la lista Target
			const nodosDeseleccionados = this.listaSeleccionados.filter(obj => obj.TIPO === 'NODO');
			if (nodosDeseleccionados) {
				// Quito la Seccion de ese nodo de las entidades seleccionadas
				nodosDeseleccionados.forEach(element => {
					const seccionDeseleccionada = this.listaSeleccionados.filter(obj => obj.Id === element.ENTIDAD.SECCION.Id)[0];
					if (seccionDeseleccionada) {
						this.listaEntidadesDestacar.push(seccionDeseleccionada);
						this.listaSeleccionados = this.listaSeleccionados.filter(obj => obj.Id !== seccionDeseleccionada.Id);
					}
				});

				this.listaSeleccionados = this.listaSeleccionados.filter(obj => obj.TIPO !== 'NODO');
				this.listaNodosSeleccionados = this.listaNodosSeleccionados.filter(obj => obj.TIPO !== 'NODO');

				// Asigno el nuevo nodo seleccionado
				if (entidadNodoMasCercano) {
					this.listaSeleccionados.push(entidadNodoMasCercano);
					this.listaNodosSeleccionados.push(entidadNodoMasCercano);

					// Asigno Seccion del nuevo Nodo Seleccionado
					const seccionNodo =  this.listaEntidades.filter(obj => obj.Id === entidadNodoMasCercano.ENTIDAD.SECCION.Id)[0];
					if (seccionNodo) {
						this.listaSeleccionados.push(seccionNodo);
						this.listaEntidadesDestacar = this.listaEntidadesDestacar.filter(obj => obj.Id !== seccionNodo.Id);
					}
				}

			}

			console.log('--- NODO mas cerca: ' + nodoMasCercano.Nombre);
			console.log('---------------------------------');
			return true;
		}

	}

	posicionarContenido(event){

		if (this.contents.length === 0){

			this.contents.push(this.contenidoSeleccionado.CONTENIDO_PLANO);
			this.contents = Object.assign([], this.contents);
		}

		if (this.esEdicion ){
			this.contenidoSeleccionado.ENTIDAD.X = event.mp[0]; // + this.offset_x_icono_contenido;
			this.contenidoSeleccionado.ENTIDAD.Y = event.mp[1]; //  + this.offset_y_icono_contenido;

			this.contents[0].setX(this.contenidoSeleccionado.ENTIDAD.X);
			this.contents[0].setY(this.contenidoSeleccionado.ENTIDAD.Y);
		}
		else{
			this.contenidoSeleccionado.X = event.mp[0]; //  + this.offset_x_icono_contenido;
			this.contenidoSeleccionado.Y = event.mp[1]; //  + this.offset_y_icono_contenido;

			this.contents[0].setX(this.contenidoSeleccionado.X);
			this.contents[0].setY(this.contenidoSeleccionado.Y);
		}

		let tipologia = this.contenidoSeleccionado.ENTIDAD ? this.contenidoSeleccionado.ENTIDAD.TIPOLOGIA_CONTENIDO : this.contenidoSeleccionado.TIPOLOGIA_CONTENIDO;
		if ((tipologia === undefined || tipologia === null)  &&  this.tipologiasContenido.length > 0) {
			tipologia = this.tipologiasContenido[0];
		}
		this.contents[0].setSimbolo(tipologia.IconoRepresentacion);
		this.contents[0].symbolStroke = Constantes.contenidoSymbolStroke;
		this.contents[0].symbolFill = Constantes.contenidoSymbolFill;
		this.contents[0].symbolStrokeWidth = Constantes.contenidoSymbolStrokeWidth;
		this.contents[0].symbolSize = Constantes.contenidoSymbolSize;

		this.contents[0].sectionHoverFill = Constantes.contenidoSectionHoverFill;
		this.contents[0].sectionHoverStroke = Constantes.contenidoSectionHoverStroke;
		this.contents[0].setIconHeight(Constantes.contenidoIconHeight);
		this.contents[0].setIconWidth(Constantes.contenidoIconWidth);
		this.contents[0].setIconAlign(tipologia.AnchorPoint);


		this.contents = [this.contents[0]];
	}

	onTabClose($event){
		this.activeAcordeonIndex = 1;
	}

	onTabOpen($event){
		this.activeAcordeonIndex = 0;
	}


	pintarSecciones(){
		const secciones = new Array<SeccionPlano>();
		this.mapSections = new Map<String, SeccionPlano>();

		this.alaSeleccionada.ENTIDAD.SECCIONS.forEach(seccion => {
			if (!this.seccionDefecto || !seccion.CoordenadasPoligono) {
				this.seccionDefecto = seccion;
			}

			const seccionCoordenadasPoligono: Array<Array<number>> = (!seccion.CoordenadasPoligono ? null : JSON.parse(seccion.CoordenadasPoligono));

			const seccionPlano = new SeccionPlano(seccion.Id, seccion.Nombre, seccionCoordenadasPoligono, seccion.ALA.PuntosSeccionScale , seccion.ALA.AristaSeccionScale);
			seccionPlano.ENTIDAD = seccion;
			seccionPlano.fill  = seccion.Color;
			seccionPlano.stroke = seccion.Color;
			seccionPlano.strokeWidth = Constantes.seccionStrokeWidth;
			seccionPlano.hoverFill = seccion.Color;
			seccionPlano.hoverStroke = seccion.Color;
			secciones.push(seccionPlano);
			this.mapSections.set(seccion.Id, seccionPlano);

		});

		this.filtrarSectionsBaja(secciones);
		// this.sections = secciones;
		console.log('sections... ' + this.sections.length);
	}

	filtrarSectionsBaja(secciones){
		const fechaVisualizacion = Date.now();
		this.sections = new Array<SeccionPlano>();
		secciones.forEach((value: SeccionPlano, key: String) => {
			console.log(key, value);
			const seccionPlano: SeccionPlano = value;
			if (seccionPlano.ENTIDAD.FechaBaja === null || seccionPlano.ENTIDAD.FechaBaja > fechaVisualizacion ){
				if (seccionPlano.ENTIDAD.FechaAlta !== null && seccionPlano.ENTIDAD.FechaAlta <= fechaVisualizacion ){
					this.sections.push(seccionPlano);
				}
			}
		});

		this.sections = this.sections;
		this.sections = Object.assign([], this.sections);
	}

	public alaSeleccionadaChange($event){
		this.alaSeleccionada = $event.value;
		this.seleccionarAla(this.alaSeleccionada);
	}

//#endregion

//#region -- IDIOMA --
public onTextChange(event: CKEditor4.EventInfo): void {

	 this.contenidoSeleccionado.Source = 'user'
	 this.contenidoSeleccionado.HtmlDetalle = event.editor.getData();


	// //  Cojemos la traduccion del contenido al idioma seleccionado
	 const contenidoIdioma = this.contenidoSeleccionado.Idiomas.get(this.idiomaSeleccionado.ENTIDAD.Codigo);

	// // Guardamos los posibles cambios del idioma
	 contenidoIdioma.htmlVisualizableDetalle = this.contenidoSeleccionado.HtmlDetalle;

	 this.contenidoSeleccionado.Idiomas.set(this.idiomaSeleccionado.ENTIDAD.Codigo, contenidoIdioma);
}



	onAudioTextChange($event){
		console.log($event);
		console.log(this.contenidoSeleccionado.AudioTexto);

		this.contenidoSeleccionado.AudioTexto = $event.textValue;

		//  Cojemos la traduccion del contenido al idioma seleccionado
		const contenidoIdioma = this.contenidoSeleccionado.Idiomas.get(this.idiomaSeleccionado.ENTIDAD.Codigo);

		// Guardamos los posibles cambios del idioma
		contenidoIdioma.AudioTexto = this.contenidoSeleccionado.AudioTexto;

		this.contenidoSeleccionado.Idiomas.set(this.idiomaSeleccionado.ENTIDAD.Codigo, contenidoIdioma);
	}

/* *********************
	playSpeech(){
		this.speech.speak({
			text: this.contenidoSeleccionado.AudioTexto,
		}).then(() => {
			console.log('Success !');
		}).catch(e => {
			console.error('An error occurred :', e);
		});
	}

	pauseSpeech(){
		return this.speech.pause({
			text: this.contenidoSeleccionado.AudioTexto,
		}).then(() => {
			console.log('Success !');
		}).catch(e => {
			console.error('An error occurred :', e);
		});
	}

	resumeSpeech(){
		return this.speech.resume({
			text: this.contenidoSeleccionado.AudioTexto,
		}).then(() => {
			console.log('Success !');
		}).catch(e => {
			console.error('An error occurred :', e);
		});
	}

	stopSpeech(){
		return this.speech.cancel({
			text: this.contenidoSeleccionado.AudioTexto,
		}).then(() => {
			console.log('Success !');
		}).catch(e => {
			console.error('An error occurred :', e);
		});
	}
************************* */

	onIdiomaChange($event) {
		const idioma = $event.value;
		if (!idioma) {
			return;
		}
		this.idiomaSeleccionado = idioma;

		// Cojemos la traduccion del contenido al idioma seleccionado
		let contenidoIdioma = this.contenidoSeleccionado.Idiomas.get(idioma.value);

		// Si no existe la creamos
		if (!contenidoIdioma) {
			contenidoIdioma = new ContenidoIdiomaFormulario();
			this.contenidoSeleccionado.Idiomas.set(idioma.value, contenidoIdioma);
		}

		// Seteamos los valores de contenidoFormulario con los valores del idioma seleccionado
		this.contenidoSeleccionado.Titulo = contenidoIdioma.Nombre;
		this.contenidoSeleccionado.Descripcion = contenidoIdioma.Descripcion;
		this.contenidoSeleccionado.HtmlDetalle = contenidoIdioma.htmlVisualizableDetalle;
		this.contenidoSeleccionado.AudioTexto = contenidoIdioma.AudioTexto;
		this.contenidoSeleccionado.NombreCorto = contenidoIdioma.NombreCorto;

		console.log('Cambiar Titulo y descripcion a la del idioma: ' + idioma.value + '(' + idioma.title + ')');
	}

//#endregion

//#region -- IMAGEN --
	// -- Image Cropper --
	fileChangeListener($event) {
		this.imageCropperVisible = true;
		const image: any = new Image();
		const file: File = $event.target.files[0];
		const nombre = file.name;
		const tipo = file.type;
		const myReader: FileReader = new FileReader();
		const that = this;
		myReader.onloadend = function (loadEvent: any) {
			image.src = loadEvent.target.result;
			that.cropper.setImage(image);
			that.sws.base64ToFile(image.src, nombre, tipo)
			.then(function(fotoFile){
				that.contenidoSeleccionado.nuevaImagenSeleccionada = fotoFile;
			});
		};
		myReader.readAsDataURL(file);
	}

	onImageDetelleHandler(event){
		const that = this;

		const file: File = event.target.files[0];
		console.log(file);
		this.contenidoSeleccionado.nuevaImagenDetalleSeleccionada = file;
		if (FileReader && file) {
			const fr = new FileReader();
			fr.onload = e => {
				this.srcNuevaImagenDetalle =  <string>e.target.result

			};
			fr.readAsDataURL(file);
		}

	}

	asignarFotoCropp($event){
		const that = this;
		this.sws.base64ToFile(this.data.image, that.contenidoSeleccionado.nuevaImagenSeleccionada.name)
		.then(function(fotoFile){
			that.contenidoSeleccionado.nuevaImagenSeleccionada = fotoFile;
			that.imageCropperVisible = false;
		});
	}

	getMensajesExpirados(_val) {
		for (const i in this.mensajesExpirados) {
			if (this.mensajesExpirados[i].value === _val) {
				return this.mensajesExpirados[i];
			}
		}
		return {};
	}

	onMostrarFormularioPrioridadDestacar($event){

		console.log('ELEMENTO A EDITAR');

	}

	onOcultarFormularioPrioridadDestacar($event){

	}

	getImagenDetallePreview(){
		if (this.contenidoSeleccionado.nuevaImagenDetalleSeleccionada) {
			return this.contenidoSeleccionado.nuevaImagenDetalleSeleccionada;
		}
		else {
			return this.contenidoSeleccionado.ImagenDetalle;
		}

	}

	mostrarBotonImagenDetalle(){

		const op1 = (this.contenidoSeleccionado.Imagen !== "assets/itsoft/images/no-contenidos-p.png" && this.contenidoSeleccionado.Imagen !== undefined) || (this.data.image !== "assets/itsoft/images/no-contenidos-p.png" && this.data.image !== undefined);
		return op1;

	}


//#endregion

//#region -- MODELO_3D
	/* ** Metodos de GroupForm ** */
	onFileSelectModelo_ios($event, fileUploadComponent) {

		this.selectorImagenModelo_ios = fileUploadComponent;
		console.log('$event.files[0] = ' + $event.files[0]);
		this.ficheroModeloSeleccionado_ios = $event.files[0];

		this.modeloSeleccionado.NombreFichero = $event.files[0].name;
	}

	onFileSelectModelo_android($event, fileUploadComponent) {

		this.selectorImagenModelo_android = fileUploadComponent;
		console.log('$event.files[0] = ' + $event.files[0]);
		this.ficheroModeloSeleccionado_android = $event.files[0];

		this.modeloSeleccionado.NombreFichero = $event.files[0].name;
	}

	onRemoveSelectModelo_ios($event?, fileUploadComponent?) {
		this.ficheroModeloSeleccionado_ios = undefined;
	}

	onRemoveSelectModelo_android($event?, fileUploadComponent?) {
		this.ficheroModeloSeleccionado_android = undefined;
	}

	public subirModelo_android() {
		if (this.ficheroModeloSeleccionado_android) {
			return this.sws.subirFicheroCMS(this.ficheroModeloSeleccionado_android, undefined, environment.CMS_3d_model_user_1, environment.CMS_3d_model_token).toPromise();
		}
		else {
			return Promise.resolve(this.modeloSeleccionado.UrlExt_android);
		}
	}

	public subirModelo_ios() {
		if (this.ficheroModeloSeleccionado_ios) {
			return this.sws.subirFicheroCMS(this.ficheroModeloSeleccionado_ios, undefined, environment.CMS_3d_model_user_1, environment.CMS_3d_model_token).toPromise();
		}
		else {
			return Promise.resolve(this.modeloSeleccionado.UrlExt_ios);
		}
	}

	guardarModelo(){
		const that = this;
		return this.subirModelo_android()
		.then(function(urlModelo){
			that.urlModeloSeleccionado_android = urlModelo;
			return that.subirModelo_ios();
		})
		.then(function(urlModelo) {
			that.urlModeloSeleccionado_ios = urlModelo;

			if (that.contenidoSeleccionado.ENTIDAD.MODELO_3D) {
				return that.entityManager.deleteMODELO_3D(that.contenidoSeleccionado.ENTIDAD.MODELO_3D)
				.then(function(resp){

					return that.entityManager.newMODELO_3D();
				});

			}
			else {
				return that.entityManager.newMODELO_3D();
			}

		})
		.then(function(MODELO_3D) {

			MODELO_3D.Nombre = that.modeloSeleccionado.Nombre;
			MODELO_3D.Descripcion = that.modeloSeleccionado.Descripcion ? that.modeloSeleccionado.Descripcion : '' ;
			MODELO_3D.FechaAlta = that.modeloSeleccionado.FechaAlta;

			MODELO_3D.UrlExt_ios = that.urlModeloSeleccionado_ios;
			MODELO_3D.IdExt_ios =  that.urlModeloSeleccionado_ios.split('/')[that.urlModeloSeleccionado_ios.split('/').length - 1];

			MODELO_3D.IdExt_android = that.urlModeloSeleccionado_android.split('/')[that.urlModeloSeleccionado_android.split('/').length - 1];
			MODELO_3D.UrlExt_android = that.urlModeloSeleccionado_android;

			MODELO_3D.NombreFichero = that.modeloSeleccionado.NombreFichero;
			MODELO_3D.FechaActualizacionFichero = that.modeloSeleccionado.FechaActualizacionFichero;

			MODELO_3D.GeocalibracionActiva = that.modeloSeleccionado.GeocalibracionActiva;
			MODELO_3D.Metros_Aparicion = that.modeloSeleccionado.Metros_Aparicion;
			MODELO_3D.Orientacion = that.modeloSeleccionado.Orientacion;
			MODELO_3D.Latitud_topLeft = that.modeloSeleccionado.Latitud_topLeft;
			MODELO_3D.Longitud_topLeft =  that.modeloSeleccionado.Longitud_topLeft;
			MODELO_3D.Latitud_topRight =  that.modeloSeleccionado.Latitud_topRight;
			MODELO_3D.Longitud_topRight =  that.modeloSeleccionado.Longitud_topRight;
			MODELO_3D.Latitud_bottomRight = that.modeloSeleccionado.Latitud_bottomRight;
			MODELO_3D.Longitud_bottomRight = that.modeloSeleccionado.Longitud_bottomRight;
			MODELO_3D.Latitud_bottomLeft = that.modeloSeleccionado.Latitud_bottomLeft;
			MODELO_3D.Longitud_bottomLeft = that.modeloSeleccionado.Longitud_bottomLeft;
			MODELO_3D.width = that.modeloSeleccionado.width;
			MODELO_3D.height = that.modeloSeleccionado.height;

			that.modeloSeleccionado.Id = MODELO_3D.Id;
			that.modeloSeleccionado.ENTIDAD = MODELO_3D;

			that.contenidoSeleccionado.ENTIDAD.IdModelo3D = MODELO_3D.Id;

			return that.entityManager.saveChanges();
		})
		.then(function(resp) {
			console.log(resp);
		})
		.catch(function(err){
			console.log(err);
		});
	}

	posicionarModelo(){
		this.appComponent.showError('No Implementado!');
	}

//#endregion

	exportarContenido(){
		window.print();
	}

	// No se usa pero lo dejo por si acaso
	exportarQR_SVG(){
		document.getElementsByClassName('view')[0].attributes[3].value = '0';

		const ambos = document.getElementById('contenedor_impresion2');
		let ambosString = new XMLSerializer().serializeToString(ambos);
		const regex2 = /assets/g;
		ambosString = ambosString.replace(regex2, environment.urlPublicacionFija + '/assets/');

		document.getElementsByClassName('view')[0].attributes[3].value = '0';
		const url2 = window.URL.createObjectURL(new Blob([ambosString], {type: 'text/plain'}));

		// Exportar svg
		return this.sws.downloadFile(url2, 'SVG_HISTORICOS.svg');
	}

	onFechaAceptar(dt, calendar, columna, tipo) {
		console.log(calendar);
		const fecha = calendar.value ? calendar.value : new Date();
		if (tipo === 'FechaAlta') {
			this.contenidoSeleccionado.FechaAlta = fecha;
		}
		if (tipo === 'FechaBaja') {
			this.contenidoSeleccionado.FechaBaja = fecha;
		}
		if (tipo === 'fAltaModelo') {
			this.modeloSeleccionado.FechaAlta = fecha;
		}
		calendar.overlayVisible=false;
	}

}




// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/views/contenidos/nuevo/nuevo.contenido.component.ts